import * as Actions from 'store/actions/app/pos.actions'

const initialState = {
  loading_recent: false,
  recent_products: [],
}

const posReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_RECENT_PRODUCTS: {
      return {
        ...state,
        loading_recent: action.payload.loading ?? false,
        recent_products: action.payload.data ?? state.recent_products,
      }
    }
    default: {
      return state
    }
  }
}

export default posReducer
